import styled from "styled-components";
import { Heading } from "../../common/Heading/Heading";
import { useTranslation } from "react-i18next";
import { media } from "../../../styles/mixins";
import { COLORS } from "../../../assets/constants/styles";
import { RoundCheckMarkGrey } from "../../../assets/images/RoundCheckMarkGrey";
import { RoundCheckMarkWhite } from "../../../assets/images/RoundCheckMarkWhite";
import { Button } from "../../common/Button/Button";
import { openExtensionStore } from "../../../helpers/various-helpers";
import { useState } from "react";
import { DemoModal } from "../../common/DemoModal/DemoModal";

export const Pricing = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <PricingComponentContainer id="pricing">
        <TitleContainer>
          <Heading size={1} text={t("pricing.title")} />
        </TitleContainer>
        <PricingContainer>
          {t("pricing.options", { returnObjects: true }).map(
            (option, index) => {
              const isPro = option.name === "Pro Plan";
              const isFree = option.name === "Personal";
              return (
                <PricingCard $isPro={isPro} key={`pricing-card-${index}`}>
                  <TopSection>
                    <Heading
                      size={2}
                      text={option.name}
                      color={isPro && COLORS.white}
                    />
                    <Price>
                      {option.price1} {option?.price2}
                    </Price>
                    <Divider />
                    <PerksContainer>
                      {option.perks.map((perk) => {
                        return (
                          <PerkContainer key={`pricing-card-${index}-${perk}`}>
                            <LogoContainer>
                              {isPro ? (
                                <RoundCheckMarkWhite />
                              ) : (
                                <RoundCheckMarkGrey />
                              )}
                            </LogoContainer>
                            <Perk>{perk}</Perk>
                          </PerkContainer>
                        );
                      })}
                    </PerksContainer>
                  </TopSection>
                  <BottomSection>
                    <Button
                      text={t("pricing.try")}
                      onClick={() => {
                        if (isFree) {
                          openExtensionStore();
                        } else {
                          setIsModalOpen(true);
                        }
                      }}
                    />
                  </BottomSection>
                </PricingCard>
              );
            }
          )}
        </PricingContainer>
      </PricingComponentContainer>
      <DemoModal
        isModalOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};

const PricingComponentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 64px;
  margin-bottom: 48px;

  ${media.tablet(`
    margin-top: 80px;
     margin-bottom: 40px;
  `)}

  ${media.laptop(`
    margin-top: 128px;
    margin-bottom: 135px;
  `)}
`;

const PricingContainer = styled.div`
  display: grid;
  width: 100%;
  gap: 16px;

  ${media.tablet(`
    grid-template-columns: 1fr 1fr 1fr;

  `)}

  ${media.laptop(`
     gap: 16px;

  `)}
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;

  ${media.tablet(`
     margin-bottom: 40px;
  `)}

  ${media.laptop(`
    margin-bottom: 70px;
  `)}
`;

const PricingCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  background: ${(props) => (props.$isPro ? "black" : COLORS.white)};
  color: ${(props) => (props.$isPro ? COLORS.white : COLORS.grey)};
  border-radius: 20px;
  height: 360px;
  justify-content: space-between;

  ${media.tablet(`
    height: 400px;
 `)}

  ${media.laptop(`
    height: 450px;
    padding: 30px 56px;
  `)}
`;

const Price = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 3px;
  margin-top: 8px;

  ${media.tablet(`
     margin-top: 20px;
 `)}
`;

const Divider = styled.div`
  width: 100%;
  border-bottom: 1px solid ${COLORS.lightGrey};
  margin: 16px 0;

  ${media.tablet(`
    margin: 27px 0 ;
`)};
`;

const PerksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
`;

const PerkContainer = styled.div`
  display: grid;
  width: 100%;
  justify-content: flex-start;
  gap: 7px;
  align-items: center;
  grid-template-columns: 1fr 10fr;
`;

const Perk = styled.div`
  font-size: 12px;
  line-height: 150%;
  letter-spacing: -0.005em;
`;

const LogoContainer = styled.div`
  height: 25px;
  display: flex;
  align-items: center;
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const BottomSection = styled.div`
  width: 100%;

  * {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;
